import axios from "axios";
import { message } from 'ant-design-vue';
import router from "./router";
import store from './store'

axios.interceptors.request.use(
    config => {
        store.commit('setLoadingVisible', true);
        if (config.url.indexOf("zserver/api") > -1 && (config.url.indexOf("authenticate") === -1 && config.url.indexOf("dog/auth_code") === -1 && config.url.indexOf("dog/challenge") === -1 && config.url.indexOf("dog/verify_digest") === -1)) {
            if (store.state.token) {
                config.headers.authorization = store.state.token;
            } else {
                router.push("/login");
                message.warn("请先登录", 2);
                return Promise.reject(new Error('no token'))
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

axios.interceptors.response.use(
    response => {
        store.commit('setLoadingVisible', false);
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        // 响应错误处理
        if (error && error.response) {
            const statusCode = error.response.status;
            if (statusCode === 401 && error.config.url.indexOf("authenticate") === -1) {
                router.push("/login");
                message.warn("未登录或登录已过期", 2);
            }
        }
        store.commit('setLoadingVisible', false);
        return Promise.reject(error);
    }
)

export default {
    install(Vue) {
        Vue.prototype.$httpGet = (url, params = {}) => {
            return new Promise((resolve, reject) => {
                axios.get(url, { params: params }).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        };

        Vue.prototype.$httpPost = (url, data = {}, headers = {}) => {
            return new Promise((resolve, reject) => {
                axios.post(url, data, { headers: headers }).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }

        Vue.prototype.$httpPut = (url, data = {}) => {
            return new Promise((resolve, reject) => {
                axios.put(url, data).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }

        Vue.prototype.$httpDel = (url, params = {}) => {
            return new Promise((resolve, reject) => {
                axios.delete(url, { params: params }).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
}